import React, { useState } from "react";
import styles from "../styles/CreateRevisionModal.module.css";

const CreateRevisionModal = ({ isOpen, onClose, onContinue }) => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const handleContinue = () => {
    if (!name.trim()) {
      setError("Введите название ревизии");
      return;
    }
    setError("");
    onContinue(name.trim());
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // предотвращаем перезагрузку формы
      handleContinue();
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>Создать ревизию</h2>
          <button className={styles.close} onClick={onClose}>
            ✕
          </button>
        </div>

        <div className={styles.body}>
          <label>Название ревизии</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Введите название..."
            className={error ? styles.errorInput : ""}
            autoFocus
          />
          {error && <p className={styles.errorText}>{error}</p>}
        </div>

        <div className={styles.footer}>
          <button className={styles.continue} onClick={handleContinue}>
            Продолжить
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateRevisionModal;
